import { useContext, useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
//Srcs
import "../../Style/pagestyle.scss";
import {
    ButtonCreate,
    SearchTextField,
    PageHeaderTitle,
} from "../../Utils/Component";

import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";
import WorkGroupCard from "./WorkGroupCard/WorkGroupCard";
import { AuthContext } from "../../Context/AuthContext";
import { useGetAllWorkGroupByMandate } from "../../Hooks/useGetAllWorkGroupByMandate";
import WorkGroupForm from "../../Components/WorkGroup/WorkGroupForm";

export default function WorkGroup() {

    const { t } = useContext(AuthContext);

    const { tableData, loading, refetch } = useGetAllWorkGroupByMandate();
    useEffect(() => {
        refetch();
    }, []);

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    return (
        <div className="page-container">
            <PageHeaderTitle
                classPage={t("class-page-title")}
                classSlash="slash-title"
                routeTo={"/work-group"}
                pageTitle={t("page_provincial_council_member")}
            />
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <ButtonCreate
                        handleOpen={handleOpen}
                        classBtn={"btn-create"}
                        classIcon={"icon-add"}
                    />

                    <WorkGroupForm
                        open={open}
                        handleClose={handleClose}
                        setRefetch={refetch}
                        dialogTitle="Create"
                    />
                </Grid>
            </Grid>
            <Box sx={{ marginTop: "20px" }}>
                <Grid container spacing={2}>
                    {loading ?
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                            <LoadingPage />
                        </Grid>
                        : tableData?.length === 0 || tableData?.length === undefined ?
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                                <EmptyData />
                            </Grid>
                            : tableData?.map((e, index) => (
                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6} key={index}>
                                    <WorkGroupCard item={e} setRefetch={refetch} />
                                </Grid>
                            ))}
                </Grid>
            </Box>
        </div>
    );
}